import React, { createContext, useState, useEffect, useMemo, ReactNode } from 'react';
import { ReactStateSetter } from '../../types.ts';

interface ThreadContextProps {
    threadId: string | null;
    setThreadId: ReactStateSetter<string | null>;
}

export const ThreadContext = createContext<ThreadContextProps>({
    threadId: null,
    setThreadId: () => {}
});

interface ThreadProviderProps {
    children: ReactNode;
}

export const ThreadProvider: React.FC<ThreadProviderProps> = ({ children }) => {
    const [threadId, setThreadId] = useState<string | null>(() =>
        sessionStorage.getItem('threadId')
    );

    useEffect(() => {
        if (threadId) {
            sessionStorage.setItem('threadId', threadId);
        } else {
            sessionStorage.removeItem('threadId');
        }
    }, [threadId]);

    const value = useMemo(() => ({ threadId, setThreadId }), [threadId, setThreadId]);

    return (
        <ThreadContext.Provider value={value}>
            {children}
        </ThreadContext.Provider>
    );
};
